// ======================================================================
// File Name       : userHistoryCourse
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { commonCallApi } from '../../utils/ApiUtils';
import { SELECT_TARGET_DATA } from '../../constants';

export function postUserCourseHistoryStatus(data) {
  const PARAM_DEFAULT = {
    selectTargetData: SELECT_TARGET_DATA.DATA,
  };

  return commonCallApi({
    path: 'learningOperation/GetStatusCourse',
    data: { ...PARAM_DEFAULT, ...data },
  });
}

export function postEachCourseStatusCount(data) {
  const PARAM_DEFAULT = {
    selectTargetData: SELECT_TARGET_DATA.DATA,
  };

  return commonCallApi({
    path: 'learningOperation/EachCourseStatusCount',
    data: { ...PARAM_DEFAULT, ...data },
  });
}

// #7386 START
export function postEachCourseCompletionStatusSummary(data) {
  return commonCallApi({
    path: 'learningOperation/EachCourseCompletionStatusSummary',
    data,
  });
}
// #7386 END
